import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { adminSignin, clearAuthRedirectState } from "slices/authSlice";
import { useDispatch, useSelector } from "react-redux";

export const STATE_LOGIN = "LOGIN";
export const STATE_SIGNUP = "SIGNUP";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .test(
      "is-valid-email-or-mobile",
      "Invalid email or mobile number",
      (value) => {
        return (
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || // Email validation
          /^[0-9]{10,15}$/.test(value) // Mobile number validation
        );
      }
    )
    .required("Email or Mobile Number is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  confirmPassword: Yup.string().when("authState", {
    is: STATE_SIGNUP,
    then: (schema) =>
      schema.oneOf([Yup.ref("password")], "Passwords must match"),
  }),
});

const AuthForm = ({ authState, showLogo, buttonText }) => {
  const redirect = useSelector((state) => state.auth.redirect);
  const loading = useSelector((state) => state.auth.loading);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLogin = authState === STATE_LOGIN;

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: async (values, { setErrors }) => {
      const { email, password } = values;

      const finaldata = {
        email: email.trim(),
        password: password.trim(),
      };

      try {
        console.log("Form Submitted:", finaldata);
        // Add your form submission logic here (e.g., API call)
        dispatch(adminSignin(finaldata));
        // toast.success("Login successful");
      } catch (error) {
        setErrors({ email: "Invalid email or password" });
      }
    },
  });
  console.log("redire", redirect);
  if (redirect) {
    navigate("/");
    dispatch(clearAuthRedirectState());
  }

  return (
    <Form onSubmit={formik.handleSubmit}>
      {showLogo && (
        <div className="text-center pb-4">
          {/* <img
            src={logo200Image}
            className="rounded"
            style={{ width: 60, height: 60, cursor: 'pointer' }}
            alt="logo"
            onClick={onLogoClick}
          /> */}
          <h1 className="text-2xl text-slate-800 dark:text-white font-bold py-3">
            Welcome back!
          </h1>
        </div>
      )}
      {/* Email/Mobile Field */}
      <FormGroup>
        <Label>Email or Mobile Number</Label>
        <Input
          type="text"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          invalid={formik.touched.email && !!formik.errors.email}
        />
        {formik.touched.email && formik.errors.email && (
          <FormFeedback>{formik.errors.email}</FormFeedback>
        )}
      </FormGroup>
      <FormGroup>
        <Label>Password</Label>
        <Input
          type="password"
          name="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          invalid={formik.touched.password && !!formik.errors.password}
        />
        {formik.touched.password && formik.errors.password && (
          <FormFeedback>{formik.errors.password}</FormFeedback>
        )}
      </FormGroup>
      <Button
        size="lg"
        className="bg-gradient-theme-left border-0"
        block
        type="submit"
      >
        {buttonText || (loading ? "Loading..." : "Login")}
      </Button>
    </Form>
  );
};

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  onChangeAuthState: PropTypes.func.isRequired,
  onLogoClick: PropTypes.func,
  buttonText: PropTypes.string,
};

AuthForm.defaultProps = {
  showLogo: true,
  onLogoClick: () => {},
};

export default AuthForm;
